import { X } from 'lucide-react'
import { useEffect } from 'react'

export const estiloInputModal =
  'min-h-12 w-full rounded-lg border border-slate-300 bg-white px-3 py-3 text-base text-slate-900 outline-none transition focus:border-emerald-500 focus:ring-2 focus:ring-emerald-100 disabled:bg-slate-100'

export function CampoModal({
  label,
  htmlFor,
  requerido = false,
  className = '',
  children,
}) {
  return (
    <div className={className}>
      <label
        htmlFor={htmlFor}
        className="mb-2 block text-sm font-semibold text-slate-700"
      >
        {label}
        {requerido && (
          <span className="ml-1 text-red-500">*</span>
        )}
      </label>

      {children}
    </div>
  )
}

export function AvisoModal({
  tipo = 'error',
  children,
}) {
  const clases = {
    error: 'border-red-200 bg-red-50 text-red-700',
    aviso: 'border-amber-200 bg-amber-50 text-amber-800',
    info: 'border-slate-200 bg-slate-50 text-slate-600',
  }

  return (
    <div
      role={tipo === 'error' ? 'alert' : undefined}
      className={`rounded-lg border px-3 py-2 text-sm font-medium ${clases[tipo]}`}
    >
      {children}
    </div>
  )
}

function ModalBase({
  abierto,
  titulo,
  tituloId,
  procesando = false,
  anchoMaximo = 'max-w-2xl',
  onCerrar,
  children,
}) {
  useEffect(() => {
    if (!abierto) return

    const alPresionarTecla = (event) => {
      if (event.key === 'Escape' && !procesando) {
        onCerrar?.()
      }
    }

    document.addEventListener('keydown', alPresionarTecla)

    return () => {
      document.removeEventListener('keydown', alPresionarTecla)
    }
  }, [abierto, procesando, onCerrar])

  if (!abierto) return null

  const alHacerClicFuera = (event) => {
    if (procesando) return

    if (event.target === event.currentTarget) {
      onCerrar?.()
    }
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 p-3 sm:p-4"
      onMouseDown={alHacerClicFuera}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby={tituloId}
        className={`max-h-[92vh] w-full ${anchoMaximo} overflow-y-auto rounded-2xl bg-white p-4 shadow-xl sm:p-8`}
      >
        <div className="flex items-start justify-between gap-4">
          <h2
            id={tituloId}
            className="text-lg font-bold text-slate-900 sm:text-xl"
          >
            {titulo}
          </h2>

          <button
            type="button"
            onClick={onCerrar}
            disabled={procesando}
            aria-label="Cerrar"
            className="shrink-0 text-slate-400 transition hover:text-slate-600 disabled:cursor-not-allowed disabled:opacity-60"
          >
            <X size={22} />
          </button>
        </div>

        {children}
      </div>
    </div>
  )
}

export default ModalBase
